import { map, pick } from 'lodash';

import { useEventEmitter, useMutation } from 'common/hooks';
import { UseMutationOptions } from 'common/types/Api.type';
import { updatePraiseApi } from '../praise.service';
import { PraiseEventData } from '../types';
import { VisibleTo } from 'common/types/visible-to.type';

export const useUpdatePraise = (options: UseMutationOptions = {}) => {
  const { emitWithSettledAfter } = useEventEmitter<PraiseEventData>('PraiseUpdated');

  const mutationResponse = useMutation(updatePraiseApi, {
    showSuccessSnackbar: true,
    transformInput: (praiseForm: any) => {
      const praise = pick(praiseForm, [
        'id',
        'receiver',
        'headline',
        'description',
        'skills',
        'tags',
        'visibleTo',
      ]);
      return {
        id: praise.id,
        receiverId: praise.receiver?.[0]?.id,
        headline: praise.headline,
        description: praise.description,
        skillIds: map(praise.skills, (skill) => skill?.id),
        tags: praise.tags,
        visibleTo: praise.visibleTo.map((v: VisibleTo) => v.id),
      };
    },
    onSuccess: async ({ data }) => {
      emitWithSettledAfter(5000, { data });
    },
    ...options,
  });
  return mutationResponse;
};

export default useUpdatePraise;
